import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { retry, take } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private renderer: Renderer2;
  private _minimized = localStorage.getItem('minimized')
    ? localStorage.getItem('minimized') === 'true'
    : true;

  constructor(private http: HttpClient, private rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  set minimized(value: boolean) {
    this._minimized = value;

    localStorage.setItem('minimized', `${this._minimized}`);

    if (this._minimized) document.body.classList.add('aside-minimize');
    else document.body.classList.remove('aside-minimize');
  }

  get minimized(): boolean {
    return this._minimized;
  }

  get logo(): string {
    return this._minimized
      ? 'assets/media/logos/smallLogo.PNG'
      : 'assets/media/logos/aplosLogo.png';
  }

  toggleMinimized(event?: Event): void {
    event?.stopPropagation();

    this._minimized = !this._minimized;

    localStorage.setItem('minimized', `${this._minimized}`);
    document.body.classList.toggle('aside-minimize');

    this.updateUserPreferences({ menu_expanded: !this._minimized })
      .pipe(take(1), retry(3))
      .subscribe();

    if (this._minimized) {
      const openListItems = document.getElementsByClassName('menu-item-open');

      if (openListItems.length)
        Array.from(openListItems).forEach((ls) => ls.classList.remove('menu-item-open'));
    } else {
      const listItems = document.querySelectorAll('.aside .aside-menu .menu-nav > .menu-item');

      listItems.forEach((listItem) => {
        const listItemMenu = listItem.querySelector('.menu-submenu');
        const listItemMenuNavContainer = listItem.querySelector(
          '.menu-submenu > .menu-subnav > .subnav-container',
        );

        if (listItem?.hasAttribute('style')) this.renderer.removeStyle(listItemMenu, 'top');

        if (listItemMenuNavContainer?.hasAttribute('style')) {
          this.renderer.removeStyle(listItemMenuNavContainer, 'max-height');
          this.renderer.removeStyle(listItemMenuNavContainer, 'overflow-y');
        }
      });
    }
  }

  updateUserPreferences(preferences): Observable<any> {
    const body = { ...preferences };

    return this.http.put(`${environment.USER_BASE}/user/preferences`, body);
  }
}
